import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const exportToPDF = (data, fileName = "exported_data") => {
  const doc = new jsPDF();

  // Check if data exists
  if (!data || data.length === 0) {
    toast.warning("No Data Available for Export");
    return;
  }

  // Dynamically get headers from the first object
  const keys = Object.keys(data[0]);
  const tableColumn = keys.map((key) => key); // header names
  const tableRows = data.map((item) =>
    keys.map((key) => item[key] !== undefined ? item[key] : "-")
  );

//   // Add title
//   doc.text("Exported Data", 14, 10);

  // Custom table styling
  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 20,
    headStyles: {
      fillColor: [0, 51, 102], // Blue color for the header
      textColor: [255, 255, 255], // White text
      fontSize: 10, // Header font size
      fontStyle: 'bold', // Bold header
    },
    bodyStyles: {
      fillColor: [255, 255, 255], // White color for rows
      textColor: [0, 0, 0], // Black text for rows
      fontSize: 8, // Row font size
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245], // Light grey for alternate rows
    },
    margin: { top: 10, left: 10, right: 10, bottom: 10 }, // Adjust margins
    tableWidth: 'auto', // Automatic table width
    theme: 'grid', // Use grid theme for borders
    columnStyles: {
      0: { cellWidth: "100px" }, // Auto width for first column
      1: { cellWidth: '100px' }, // Auto width for second column
    },
  });

  // Save the PDF
  doc.save(`${fileName}.pdf`);
};
